import axios from "./../../http/axios";
import {
  GET_SCHEMAS,
  GET_ASSETS_SCHEMAS,
  GET_CONTRACT_SCHEMAS,
  GET_EPC_SCHEMAS,
  SET_SCHEMAS_TEMPLATES,
  SAVE_NAME,
  ADD_SCHEMA,
  SCHEMAS_ERROR,
  GET_SCHEMA_BY_ID,
  EDIT_SCHEMA,
  DELETE_SCHEMA,
  token, EMPTY_SCHEMA_TEMPLATE,
} from "./types";

export const getSchemas = archive => dispatch => {
  const url = `user-schemas/UserSchema/${archive ? "?archived=1" : ""}`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SCHEMAS,
        payload: res.data
      });
    });
};

export const getSchemaById = id => dispatch => {
  const url = `user-schemas/UserSchema/${id}/`;
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_SCHEMA_BY_ID,
        payload: res.data
      });
    });
};
export const emptySchemas = () => dispatch => {
  return dispatch({
    type: EMPTY_SCHEMA_TEMPLATE,
  });
};

export const getAssetsSchemas = () => dispatch => {
  const url = "schemas/asset-model/";
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_ASSETS_SCHEMAS,
        payload: res.data
      });
    });
};

export const getContractSchemas = () => dispatch => {
  const url = "schemas/contract-model/";
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_CONTRACT_SCHEMAS,
        payload: res.data
      });
    });
};

export const getEpcSchemas = () => dispatch => {
  const url = "/schemas/epc-model/";
  return axios
    .get(url, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: GET_EPC_SCHEMAS,
        payload: res.data
      });
    });
};
export const setSchemasTemplates = data => async dispatch => {
  const url = "/user-schemas/checked-schemas/";
  return await axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: SET_SCHEMAS_TEMPLATES,
        payload: res.data
      });
    });
};
export const saveName = payload => ({
  type: SAVE_NAME,
  payload
});

export const addSchema = data => dispatch => {
  const url = "user-schemas/UserSchema/";
  return axios
    .post(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: ADD_SCHEMA,
        payload: res.data
      });
    })
    .catch(error => {
      return dispatch({ type: SCHEMAS_ERROR, payload: error.response });
    });
};

export const editSchema = (data, id) => dispatch => {
  const url = `/user-schemas/UserSchema/${id}/`;
  return axios
    .put(url, data, {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: EDIT_SCHEMA,
        payload: res.data
      });
    })
    .catch(error => {
      return dispatch({ type: SCHEMAS_ERROR, payload: error.response });
    });
};

export const deleteSchemas = ( id) => dispatch => {
  const url = `/user-schemas/UserSchema/${id}/`;
  return axios
    .delete(url , {
      headers: {
        Authorization: "Token " + token
      }
    })
    .then(res => {
      return dispatch({
        type: DELETE_SCHEMA,
        payload: res
      });
    })
    .catch(error => {
      return dispatch({ type: SCHEMAS_ERROR, payload: error.response });
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/schemas.js